module.exports = __webpack_public_path__ + "static/img/addwx-bg.cad4b66f.png";